__webpack_require__.p = "//sf-obj.tiktokforbusiness-learning-center.com/obj/ad-se-tt4b-academy-sg/ad/se/tt4b_academy_portal/";